import { Component, ChangeDetectionStrategy, Input, ElementRef, AfterViewChecked } from '@angular/core';
import { NotificationBarService } from '@features/layout/notification-bar/notification-bar.service';
import { PlatformService } from '@core/services/platform.service';
import { SafePipe } from '@shared/safe/safe.pipe';
import { SvgIconComponent } from '../../../@shared/svg-icon/svg-icon.component';
import { InterceptLinksDirective } from '../../../@shared/intercept-links/intercept-links.directive';
import { NgIf, NgStyle } from '@angular/common';

@Component({
    selector: 'app-notification-bar',
    templateUrl: './notification-bar.component.html',
    styleUrls: ['./notification-bar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgIf, NgStyle, InterceptLinksDirective, SvgIconComponent, SafePipe]
})
export class NotificationBarComponent implements AfterViewChecked {
    @Input()
    public textColor?: string;

    @Input()
    public backgroundColor?: string;

    @Input()
    public content?: string;

    @Input()
    public active?: boolean;

    constructor(
        private readonly notificationBarService: NotificationBarService,
        private readonly el: ElementRef,
        private readonly platformService: PlatformService
    ) {}

    public ngAfterViewChecked(): void {
        this.setNotificationBar();
    }

    public onCloseNotification(): void {
        this.active = false;
        setTimeout(() => {
            this.setNotificationBar();
        }, 0);
    }

    private setNotificationBar(): void {
        if (this.platformService.isBrowser) {
            this.notificationBarService.setNotificationBarEl(this.el.nativeElement);
        }
    }
}
